// Särredovisning av MATCHi-avräknade betalningar (C3/BES-004).
//
// En delad rad så formuleringen är identisk på alla intäktsytor — hallen ska
// aldrig behöva undra om "Omsättning" på en skärm betyder samma sak som på en
// annan. Renderar ingenting när beloppet är 0, så halllar utan MATCHi-integration
// (alla utom AP Nacka idag) ser ingen skillnad alls.
//
// Semantik: beloppet ligger UTANFÖR Boply-intäkten. Anroparen har redan dragit
// bort det ur sin totalsumma — den här raden visar bara vad som drogs bort.
import { useTranslation } from "react-i18next";
import { formatPrice } from "@/utils/formatPrice";

interface Props {
  /** MATCHi-avräknat belopp i öre. Raden döljs när 0. */
  valueMinor: number;
  currency?: string;
  /** "row" = etikett + belopp på samma rad. "card" = KPI-stil, matchar summeringskorten. */
  variant?: "row" | "card";
  className?: string;
}

export default function MatchiSettledRow({
  valueMinor,
  currency = "SEK",
  variant = "row",
  className,
}: Props) {
  // Egen namespace-bindning: ytorna använder både default-ns och "admin".
  const { t } = useTranslation("admin");
  if (!valueMinor) return null;

  const amount = formatPrice({ valueMinor, currency });

  if (variant === "card") {
    return (
      <div className={className}>
        <p className="text-xs text-muted-foreground">{t("reports.matchi.settled")}</p>
        <p className="text-2xl font-bold tabular-nums">{amount}</p>
        <p className="text-xs text-muted-foreground mt-1">{t("reports.matchi.hint")}</p>
      </div>
    );
  }

  return (
    <div className={className ?? "text-sm text-muted-foreground"}>
      <div className="flex justify-between gap-4">
        <span>{t("reports.matchi.settled")}</span>
        <span className="tabular-nums">{amount}</span>
      </div>
      <p className="text-xs mt-0.5">{t("reports.matchi.hint")}</p>
    </div>
  );
}
